





















































import InvoiceDetails from '@accounting/components/details/invoice-details/invoice-details.vue';
import { Invoice } from '@accounting/interfaces/invoice';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import InvoiceSummaryCard from '@accounting/components/others/invoice-summary-card/invoice-summary-card.vue';

@Component({
  name: 'bpc-invoice-shopping-cart-wizard-preview-step',
  components: {
    'bpc-invoice-details': InvoiceDetails,
    'bpc-invoice-summary-card': InvoiceSummaryCard,
  },
})
export default class InvoiceShoppingCartWizardPreviewStep extends Vue {
  $refs: {
    invoiceDetails: InstanceType<typeof InvoiceDetails> & {
      printInvoice(): Promise<void>;
      forcePrintInvoice(): Promise<void>;
    };
  };
  @Prop({ type: String }) readonly invoiceToken: string;

  invoice: Invoice = null;
  loading: boolean = false;
  showErrorMessage = false;
  errorMessage = null;
  printing = false;

  get nextStepEnabled(): boolean {
    return (
      !this.loading &&
      this.invoice &&
      this.invoice.status === 'to_pay' &&
      ((this.invoice.invoice_type === 'invoice' && this.allowedToPayOnlineInvoices) ||
        this.invoice.invoice_type === 'ticket')
    );
  }

  get generateInvoiceText(): string {
    return this.invoice.invoice_type == 'ticket'
      ? 'global.generate_ticket.label'
      : 'global.generate_invoice.label';
  }
  get checkoutText(): string {
    return this.invoice
      ? this.invoice.invoice_type == 'ticket'
        ? 'global.pay_the_ticket'
        : 'global.pay_the_invoice'
      : 'global.checkout';
  }

  get allowedToPayOnlineInvoices(): boolean {
    const allowed = this.$authService.allowedToPayOnlineInvoices(this.invoice);
    return allowed && this.invoice?.invoice_type !== 'credit_note';
  }

  get showWarningMessage(): boolean {
    return !!this.warningMessage;
  }

  get warningMessage(): string | null {
    if (this.loading) {
      return null;
    }
    if (!this.invoice) {
      return null;
    }

    if (this.invoice.status === 'paid') {
      return 'accounting.warning_message_the_invoice_is_already_paid';
    }

    if (this.invoice.status !== 'to_pay') {
      return 'accounting.warning_message_the_invoice_is_not_in_to_pay_status';
    }

    return null;
  }

  mounted() {
    this.getInvoice();
  }

  invoiceCheckout() {
    this.$emit('invoice-checkout', this.invoice);
  }

  async getInvoice() {
    this.loading = true;
    this.showErrorMessage = false;
    const url = `${this.$bpcApiRouteHelper.getEntityPath('invoices', 'raw')}/${this.invoiceToken}`;
    try {
      const res = await this.$bpcApi.get(url).toPromise();
      this.invoice = res.data;
    } catch (e) {
      this.errorMessage = 'accounting.invoice_preview_not_found'; // TODO find warning message
      this.showErrorMessage = true;
    }
    this.loading = false;
  }

  async printInvoice() {
    this.printing = true;
    this.$refs.invoiceDetails.forcePrintInvoice().then(res => {
      this.printing = false;
    });
  }
}
